import { FileModel } from "../models/shared/file.model"

export class NotiSettingModel {
    startDateTime: Date = null!
    endDateTime: Date = null!
    dtlAlert: String = ''
    active: boolean = null!
}

export class ServerNotiModel {
    notiSysId: number = null!
    dtlAlert: string = ''
    notiSystemPath: string = ''
    startDatetime: Date = null!
    endDatetime: Date = null!
    updateUser: string = ''
    updateDate: string = ''
    status: number = null!
    notiFile: FileModel = new FileModel
    alertPicTablet: FileModel = new FileModel
    alertPicMobile: FileModel = new FileModel
    active: boolean = false
}